
import Vue from "vue";
export default Vue.extend({
	props: {
		value: Boolean,
		label: String,
		data: String
	},
	methods: {
		onValue(event:boolean) {
			this.$emit("input", event);
		}
	}
});
